module.exports = __webpack_public_path__ + "media/images/messagecards/blue-2c3ae333c6c9a1b252114312d3e73b2c.jpg";